import React, { useState, useEffect } from 'react';

const EditableInput = React.memo(function EditableInput({
  phraseId,
  value,
  error,
  onChange,
}) {
  // 🏎️ Use local state for fast, focused typing
  const [localValue, setLocalValue] = useState(value || "");

  // Update local state if the server/parent value changes
  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    // Only update the parent if the value actually changed
    if (localValue !== value) {
      onChange(phraseId, localValue);
    }
  };

  return (
    <div>
      <input
        className={`form-control form-control-sm ${error ? "is-invalid" : ""}`}
        type="text"
        name={phraseId}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={(e) => e.target.select()}
      />
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
});

export default EditableInput;